import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { MessageSquareWarning } from "lucide-react";

import { InputTextarea, SubmitLoaderButton } from "components/atoms";
import {
  AddRejectReasonAction,
  UpdateRejectReasonAction,
} from "store/middlewares/dataManagement/rejectReason";
import { Label, Button } from "components/ui";
import { closeAdminModal } from "store/slices/common/adminModal.slice";

function ModalEditRejectReason({ row, type, filter }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  const handleSubmit = (values) => {
    let tempObj = { ...values, type };
    if (row) {
      tempObj = {
        ...tempObj,
        note: values.note.trim(),
        id: row?.id,
        onSuccess: () => formik.setSubmitting(false),
        onError: () => setFormError(true),
      };
      dispatch(UpdateRejectReasonAction(tempObj));
    } else {
      dispatch(
        AddRejectReasonAction({
          ...tempObj,
          filter,
          onSuccess: () => formik.setSubmitting(false),
          onError: () => setFormError(true),
        }),
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      note: row?.note ? row?.note : "",
    },
    validationSchema: Yup.object({
      note: Yup.string().required("Reason is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit} className="grid gap-5">
      {/* Title with icon */}
      <div className="flex items-center gap-3.5">
        <div className="flex size-11 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-700">
          <MessageSquareWarning className="size-5" aria-hidden="true" />
        </div>
        <h2 className="text-xl font-bold text-foreground">
          {row ? "Edit reason" : "Add reason"}
        </h2>
      </div>

      {/* Inputs (Stacked label + textarea) */}
      <div className="grid gap-4">
        <div className="flex flex-col gap-1.5">
          <Label>Reason</Label>
          <InputTextarea
            textareaClassName="rounded-lg w-full px-3 py-2 no-scrollbar"
            isRequired={false}
            name="note"
            maxLength={250}
            onChange={(e) => {
              const cleaned = e.target.value.replace(/^\s+/, "");
              formik.setFieldValue("note", cleaned);
            }}
            onBlur={formik.handleBlur}
            error={formik.errors.note && formik.touched.note}
            errorMsg={formik.errors.note}
            value={formik.values.note}
            placeholder="Enter reason"
          />
        </div>
      </div>

      {/* Actions */}
      <div className="flex justify-end gap-3">
        <Button
          type="button"
          variant="outline"
          onClick={() => dispatch(closeAdminModal())}
        >
          Cancel
        </Button>
        <SubmitLoaderButton
          btnText={row ? "Update" : "Add"}
          isDisable={formik.isSubmitting && !formError}
        />
      </div>
    </form>
  );
}

export default ModalEditRejectReason;